/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Grid } from 'semantic-ui-react';
import m from '@utils/strings';
import { resetBeneficiarioState } from '@store/actions/index';

class AreaResultadoError extends Component {

    resetBeneficiarioState = () => {
        this.props.setInitialFieldsState();
        this.props.resetBeneficiarioState();
    }

    render() {
        let { msgErrorApi } = this.props;

        return (
            <Grid columns='equal' style={{ marginRight: 365, marginTop: 50 }}>
                <Grid.Column key='1'>
                    <div className={"div-area-resultado-autorizacao-ps"}>
                        <div>
                            <label id={"label-erro-servico"}>
                                {m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_API_ERROR}
                            </label>
                        </div>
                        <div>
                            <label id={"label-erro-servico-subtitulo"}>
                                {
                                    (msgErrorApi ?? []).length > 0
                                        ? msgErrorApi
                                        : m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_API_ERROR_SUBTITULO
                                }
                            </label>
                        </div>
                        <div className={"div-separador-top-bottom-25"}>
                            <hr className={"hr-class"} style={{ marginRight: 400 }} />
                        </div>
                        <div className={"div-separador-top-10"}>
                            <Button
                                onClick={this.resetBeneficiarioState}
                                className={"btn-default-cemig"}>
                                {m.TELA_CONSULTA_PRONTO_SOCORRO.LABEL_NOVO_ATENDIMENTO} (ENTER)
                                </Button>
                        </div>
                    </div>
                </Grid.Column>
            </Grid>
        )
    }
}

export default connect(null, { resetBeneficiarioState })(AreaResultadoError)
